import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29.7433 11.1998H4.16924C2.28085 11.1998 0.75 12.7264 0.75 14.6096V29.7548C0.75 31.638 2.28085 33.1646 4.16924 33.1646H29.7433C31.6317 33.1646 33.1625 31.638 33.1625 29.7548V14.6096C33.1625 12.7264 31.6317 11.1998 29.7433 11.1998Z",
			stroke: "#7673AF",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.97731 11.1999L19.1344 1.28604C20.4693 0.351872 22.3194 0.667155 23.2679 2.01003L29.7434 11.2116",
			stroke: "#7673AF",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7595 11.2007L24.4622 3.70398",
			stroke: "#7673AF",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.27242 11.1998V33.1646",
			stroke: "#7673AF",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.1629 19.0717H24.3338C22.226 19.0717 20.5164 20.7765 20.5164 22.8784C20.5164 24.9803 22.226 26.6852 24.3338 26.6852H33.1629",
			stroke: "#7673AF",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		})
	]
});
export default SvgWalletIcon;
